import {getBackendAssetUrl} from '@shared/api';
import {MarketplaceItem} from '../types';
import {MarketplaceItemOnBackend} from './backendTypes';

export const mapMarketplaceItemFromBackend = ({
  id,
  type,
  title,
  description,
  price,
  image_url,
}: MarketplaceItemOnBackend): MarketplaceItem => {
  return {
    id,
    type,
    title,
    description,
    price,
    imageUrl: getBackendAssetUrl(image_url),
  };
};
